import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export type PartialDebitData = {
  iban?: string
  bic?: string
  payer_name?: string
  payer_street?: string
  payer_city?: string
  payer_is_holder?: boolean
  holder_name?: string
  holder_street?: string
  holder_city?: string
  acknowledged?: boolean
}

const paymentData = createSlice({
  name: 'paymentData',
  initialState: {
    method: '',
    debitData: {
      iban: '',
      bic: '',
      payer_name: '',
      payer_street: '',
      payer_city: '',
      payer_is_holder: false,
      holder_name: '',
      holder_street: '',
      holder_city: '',
      acknowledged: false,
    } as PartialDebitData,
  },
  reducers: {
    setPaymentMethod(state, action: PayloadAction<string>) {
      state.method = action.payload
    },
    updateDebitData(state, action: PayloadAction<PartialDebitData>) {
      state.debitData = { ...state.debitData, ...action.payload }
    },
  },
})

export const { setPaymentMethod, updateDebitData } = paymentData.actions
export default paymentData.reducer
